import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  PaidNFSeStatusFilter,
} from 'src/app/services/administrative-consolidated-schedules-report.service';
import {
  DoctorV2Service,
  ListDoctorsResponse,
} from 'src/app/services/doctor-v2.service';

export type PaidAdvancedFilters = {
  doctorId: number | null;
  doctorName: string | null;
  nfseStatus: PaidNFSeStatusFilter | null;
};

@Component({
  selector: 'app-paid-consolidated-schedules-filters-modal',
  templateUrl: './paid-filters.modal.html',
  styleUrls: ['./paid-filters.modal.scss'],
})
export class PaidConsolidatedSchedulesFiltersModalComponent {
  form: FormGroup;
  doctors: Array<{ id: number; name: string }> = [];
  nfseStatusOptions: Array<{ label: string; value: PaidNFSeStatusFilter | null }> = [
    { label: 'Todos', value: null },
    { label: 'Emitida', value: 'emitted' },
    { label: 'Não emitida', value: 'not_emitted' },
    { label: 'Erro', value: 'error' },
  ];

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<PaidConsolidatedSchedulesFiltersModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { initial: PaidAdvancedFilters | null },
    private readonly doctorService: DoctorV2Service
  ) {
    this.form = this.fb.group({
      doctorId: [data?.initial?.doctorId ?? null],
      nfseStatus: [data?.initial?.nfseStatus ?? null],
    });

    this.doctorService.findAll().subscribe((list: ListDoctorsResponse[]) => {
      this.doctors = (list || []).map((doctor) => ({
        id: doctor.id,
        name: doctor.name,
      }));
    });
  }

  close(): void {
    this.dialogRef.close('close');
  }

  apply(): void {
    const raw = this.form.getRawValue() as {
      doctorId: number | null;
      nfseStatus: PaidNFSeStatusFilter | null;
    };

    const selectedDoctor = this.doctors.find(
      (doctor) => doctor.id === raw.doctorId
    );

    const payload: PaidAdvancedFilters = {
      doctorId: raw.doctorId ?? null,
      doctorName: selectedDoctor ? selectedDoctor.name : null,
      nfseStatus: raw.nfseStatus ?? null,
    };

    this.dialogRef.close(payload);
  }
}
